import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import styles from "../../../../styles/serviceAgreements.module.scss";
import { useNavigate } from "react-router";
import {setEasyPayEnrollAgrNum} from "../../../../reduxStore/myAccount/accountSummarySlice";

function ServiceAgreementsNotEnrolled({ saNotEnrolled = [], labels, onSave }) {
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      salesAgreementNumbers: [],
    },
  });

  const dispatch = useDispatch();

  const selected = watch("salesAgreementNumbers", []);
  const nav = useNavigate();
  useEffect(() => {
    const values = getValues("salesAgreementNumbers") || [];
    const validValues = saNotEnrolled.map((s) => String(s.salesAgrNum));
    const filtered = values.filter((v) => validValues.includes(String(v)));
    if (filtered.length !== values.length) {
      setValue("salesAgreementNumbers", filtered);
    }
  }, [saNotEnrolled, getValues, setValue]);

  const saveChanges = handleSubmit((data) => {
    dispatch(setEasyPayEnrollAgrNum(data.salesAgreementNumbers));
    nav("/my-account/payments/enroll");
  });

  return (
    <form onSubmit={saveChanges}>
      <div className="row">
        <div className="col-12">
          <div className={`row mb-16 ${styles["tru-mma-main-content-box"]} ${styles["bg-white"]}`}>
            <div className={`${styles["p-10"]} ${styles["mt-10"]}`}>
              {saNotEnrolled.length > 0 ? (
                saNotEnrolled.map((sa, i) => {
                  const value = String(sa.salesAgrNum);
                  const checkboxId = `agreement-${i}`;
                  return (
                    <div
                      className={`col-12 custom-control custom-checkbox d-flex align-items-center ${styles["mb-10"]} ${styles["mt-10"]}`}
                      key={checkboxId}
                    >
                      <Controller
                        name="salesAgreementNumbers"
                        control={control}
                        render={({ field }) => {
                          const checked =
                            Array.isArray(field.value) &&
                            field.value.includes(value);
                          const onChange = (e) => {
                            const checkedNow = e.target.checked;
                            const current = Array.isArray(field.value)
                              ? [...field.value]
                              : [];
                            if (checkedNow) {
                              field.onChange([...current, value]);
                            } else {
                              field.onChange(
                                current.filter((v) => v !== value)
                              );
                            }
                          };

                          return (
                            <input
                              id={checkboxId}
                              type="checkbox"
                              className="custom-control-input"
                              checked={checked}
                              onChange={onChange}
                              name={field.name}
                            />
                          );
                        }}
                      />
                      <label
                        className={`custom-control-label ${styles["gfs-20"]} ${styles["gfw-3"]}`}
                        htmlFor={checkboxId}
                      >
                        {sa.svcLineDesc}
                      </label>
                    </div>
                  );
                })
              ) : (
                <p className="text-muted">No service agreements available.</p>
              )}
            </div>

            <div className={`col-12 d-flex ${styles["mb-20"]}`}>
              <button
                type="submit"
                id="easyPaySettingsSubmit"
                disabled={selected.length === 0 || isSubmitting}
                className={`${styles["bg-yellow"]} btn btn-lg ${styles["btn"]} ${styles["btn-lg"]} ${styles["mb-10"]} ${styles["text-white"]} ${styles["gfw-4"]}`}
              >
                {labels?.epEnroll ?? "Enroll"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

ServiceAgreementsNotEnrolled.propTypes = {
  saNotEnrolled: PropTypes.arrayOf(
    PropTypes.shape({
      salesAgrNum: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      svcLineDesc: PropTypes.string.isRequired,
    })
  ),
  labels: PropTypes.shape({
    epEnroll: PropTypes.string,
  }),
  onSave: PropTypes.func,
};

export default ServiceAgreementsNotEnrolled;
